var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ViewInsuranceType } from "./view";
import LocalStorageService from "../../services/localStorage";
import { patchInsuranceTypeClearData, postInsuranceTypeClearData, } from "../../store/insuranceType/actions";
import { clearDataPutAvatar, putAvatar } from "../../store/avatar/actions";
import { deleteEntity, deleteEntityClearData, } from "../../store/delete/actions";
import { useInsuranceTypeGetAll } from "../../fnx/insuranceType/InsuranceTypeGetAll";
import { useInsuranceTypeCreate } from "../../fnx/insuranceType/InsuranceTypeCreate";
import { useInsuranceTypePatch } from "../../fnx/insuranceType/InsuranceTypePatch";
import { LoadingAFY, position, typeAlert, typeLoaders, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import showToast from "../../services/toast";
import { themeCore } from "../../assets/themes/theme";
import { insuranceTypeDataForm } from "./insuranceTypeDTO";
import { showToastSuccessMessage } from "../../fnx/sendSuccessMessage";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { hasPermission } from "../../services/getNavigationPages";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
export var InsuranceTypeAdmin = function () {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var _b = useState(false), triggerPost = _b[0], setTriggerPost = _b[1];
    var _c = useState(false), triggerPatch = _c[0], setTriggerPatch = _c[1];
    var _d = useState([]), insuranceTypeOptions = _d[0], setInsuranceTypeOptions = _d[1];
    var _e = useState([]), insuranceTypeList = _e[0], setInsuranceTypeList = _e[1];
    var listClientId = useState([])[0];
    var _f = useState(false), openDrawer = _f[0], setOpenDrawer = _f[1];
    var _g = useState(false), openModalConfirmDelete = _g[0], setOpenModalConfirmDelete = _g[1];
    var _h = useState(false), openModal = _h[0], setOpenModal = _h[1];
    var _j = useState(false), openModalCloneConfirm = _j[0], setOpenModalCloneConfirm = _j[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var _k = useState(null), avatarFile = _k[0], setAvatarFile = _k[1];
    var _l = useState(false), isUpdate = _l[0], setIsUpdate = _l[1];
    var _m = useState(null), itemModal = _m[0], setitemModal = _m[1];
    var _o = useState(""), nameSearch = _o[0], setNameSearch = _o[1];
    var _p = useState(), bodyRequest = _p[0], setBodyRequest = _p[1];
    var _q = useState(insuranceTypeDataForm), dataForm = _q[0], setDataForm = _q[1];
    var _r = useState(""), titleDrawer = _r[0], setTitleDrawer = _r[1];
    var _s = useState(1), insuranceTypePage = _s[0], setInsuranceTypePage = _s[1];
    var _t = useState(20), insuranceTypeLimit = _t[0], setInsuranceTypeLimit = _t[1];
    var _u = useState(0), countPagination = _u[0], setCountPagination = _u[1];
    var _v = useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _v[0], setSeeToast = _v[1];
    var _w = useInsuranceTypeGetAll(trigger, clientId, nameSearch, insuranceTypePage, insuranceTypeLimit), responseInsuranceType = _w.responseInsuranceType, errorInsuranceType = _w.errorInsuranceType, loadingInsuranceType = _w.loadingInsuranceType;
    var _x = useInsuranceTypeCreate(triggerPost, bodyRequest), responsePostInsuranceType = _x.responsePostInsuranceType, errorPostInsuranceType = _x.errorPostInsuranceType, loadingPostInsuranceType = _x.loadingPostInsuranceType;
    var _y = useInsuranceTypePatch(triggerPatch, bodyRequest), responsePatchInsuranceType = _y.responsePatchInsuranceType, errorPatchInsuranceType = _y.errorPatchInsuranceType, loadingPatchInsuranceType = _y.loadingPatchInsuranceType;
    var permissions = {
        create: hasPermission("admin-product-type-create"),
        read: hasPermission("admin-product-type-view"),
        update: hasPermission("admin-product-type-edit"),
        delete: hasPermission("admin-product-type-delete"),
    };
    var _z = useSelector(function (state) { return ({
        responsePutAvatar: state.Avatar.responsePutAvatar,
        errorPutAvatar: state.Avatar.errorPutAvatar,
        loadingPutAvatar: state.Avatar.loadingPutAvatar,
    }); }), responsePutAvatar = _z.responsePutAvatar, errorPutAvatar = _z.errorPutAvatar, loadingPutAvatar = _z.loadingPutAvatar;
    var _0 = useSelector(function (state) { return ({
        responseDeleteEntity: state.DeleteEntity.responseDeleteEntity,
        loadingDeleteEntity: state.DeleteEntity.loadingDeleteEntity,
        errorDeleteEntity: state.DeleteEntity.errorDeleteEntity,
    }); }), responseDeleteEntity = _0.responseDeleteEntity, loadingDeleteEntity = _0.loadingDeleteEntity, errorDeleteEntity = _0.errorDeleteEntity;
    useEffect(function () {
        if (!(responseInsuranceType === null || responseInsuranceType === void 0 ? void 0 : responseInsuranceType.data)) {
            setTrigger(true);
        }
    }, []);
    useEffect(function () {
        var _a;
        if (responseInsuranceType && ((_a = responseInsuranceType === null || responseInsuranceType === void 0 ? void 0 : responseInsuranceType.data) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var newInsuranceTypeList = responseInsuranceType.data.map(function (item) { return ({
                id: item.id,
                title: item.description,
                logo: item.logoUrl,
            }); });
            setInsuranceTypeList(newInsuranceTypeList);
            if (Array.isArray(responseInsuranceType.data)) {
                setInsuranceType(responseInsuranceType.data);
            }
        }
        if (responseInsuranceType === null || responseInsuranceType === void 0 ? void 0 : responseInsuranceType.pagingInfo) {
            setCountPagination(responseInsuranceType === null || responseInsuranceType === void 0 ? void 0 : responseInsuranceType.pagingInfo.totalItems);
        }
        if (responseInsuranceType) {
            setTrigger(false);
        }
    }, [responseInsuranceType]);
    useEffect(function () {
        if (responsePostInsuranceType && (responsePostInsuranceType === null || responsePostInsuranceType === void 0 ? void 0 : responsePostInsuranceType.data)) {
            showToastSuccessMessage("Tipo de producto creado con éxito.", typeAlert.success, setSeeToast);
            dispatch(postInsuranceTypeClearData());
            dispatch(putAvatar("ProjectType", responsePostInsuranceType.data.id, avatarFile));
            setAvatarFile(null);
            setTriggerPost(false);
        }
        else if (errorPostInsuranceType) {
            showErrorToast(errorPostInsuranceType, setSeeToast, t);
            setTriggerPost(false);
        }
    }, [responsePostInsuranceType, errorPostInsuranceType]);
    useEffect(function () {
        if (responsePutAvatar && (responsePutAvatar === null || responsePutAvatar === void 0 ? void 0 : responsePutAvatar.url)) {
            showToastSuccessMessage("Tipo de producto actualizado con éxito.", typeAlert.success, setSeeToast);
            dispatch(clearDataPutAvatar());
            setTrigger(true);
        }
        else if (errorPutAvatar) {
            showErrorToast(errorPutAvatar, setSeeToast, t);
        }
    }, [responsePutAvatar, errorPutAvatar]);
    useEffect(function () {
        if (responseDeleteEntity) {
            showToastSuccessMessage("Tipo de producto eliminado con éxito.", typeAlert.success, setSeeToast);
            dispatch(deleteEntityClearData());
            setTrigger(true);
        }
        else if (errorDeleteEntity) {
            showErrorToast(errorDeleteEntity, setSeeToast, t);
        }
    }, [responseDeleteEntity, errorDeleteEntity]);
    useEffect(function () {
        if (responsePatchInsuranceType && responsePatchInsuranceType.data) {
            setOpenModal(false);
            if (avatarFile != null) {
                dispatch(putAvatar("ProjectType", responsePatchInsuranceType.data.id, avatarFile));
                setAvatarFile(null);
            }
            else {
                showToastSuccessMessage("Tipo de producto actualizado con éxito.", typeAlert.success, setSeeToast);
            }
            setTrigger(true);
            setTriggerPatch(false);
            dispatch(patchInsuranceTypeClearData());
        }
        else if (errorPatchInsuranceType) {
            showErrorToast(errorPatchInsuranceType, setSeeToast, t);
            setTriggerPatch(false);
        }
    }, [responsePatchInsuranceType, errorPatchInsuranceType]);
    useEffect(function () {
        if (nameSearch) {
            setTrigger(true);
        }
        else {
            onCloseSearch();
        }
    }, [nameSearch]);
    var setInsuranceType = function (responseSponsor) {
        var dataBranches = [];
        responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.map(function (item) {
            if (item.id && item.description) {
                dataBranches.push({
                    id: item.id,
                    name: item.description,
                    active: false,
                });
            }
        });
        setInsuranceTypeOptions(dataBranches);
    };
    var searchFilter = function (term) {
        setNameSearch(term);
    };
    var onCloseSearch = function () {
        setNameSearch("");
        setTrigger(true);
    };
    var filterStatus = function (item) {
        var idSponsor = item === null || item === void 0 ? void 0 : item.sponsor.map(function (item) { return item.id; }).join(",");
        setTrigger(true);
    };
    var showEdit = function (row) {
        setDataForm(__assign(__assign({}, dataForm), { id: row.id, Name: row.title, clientId: row.clientId }));
    };
    var handleSubmitInsuranceType = function (dataInsuranceType, file) {
        if (isUpdate) {
            setBodyRequest({
                id: dataInsuranceType.id,
                description: dataInsuranceType.Name,
            });
            setOpenDrawer(false);
            setTriggerPatch(true);
            setAvatarFile(file);
        }
        else {
            setBodyRequest({
                description: dataInsuranceType.Name,
            });
            setOpenDrawer(false);
            setTriggerPost(true);
            setAvatarFile(file);
        }
        setOpenModal(false);
    };
    var handleOnClickAdd = function () {
        setIsUpdate(false);
        setOpenDrawer(true);
        setTitleDrawer("Agregar tipo de producto");
        setDataForm(__assign(__assign({}, dataForm), { id: "", Name: "", clientId: "", Img: "" }));
    };
    var onClickContextMenu = function (opt, item) {
        switch (opt.id) {
            case "1":
                setIsUpdate(true);
                setTitleDrawer("Modificar tipo de producto");
                setOpenDrawer(true);
                showEdit(item);
                break;
            case "2":
                setOpenModalConfirmDelete(true);
                setitemModal(item);
                break;
            case "3":
                setitemModal(item);
                setOpenModalCloneConfirm(true);
        }
    };
    var clickView = function (view) {
        setitemModal(view);
    };
    var handleCloseCloneModal = function () {
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
    };
    var handleDelete = function () {
        setOpenModalConfirmDelete(false);
        dispatch(deleteEntity({
            id: itemModal.id,
            entity: "ProjectTypeEntity",
            idUser: clientId,
        }));
    };
    var handleClone = function () {
        var body = {
            clientId: itemModal.clientId,
            name: itemModal.title,
        };
        setOpenModal(false);
        setOpenModalCloneConfirm(false);
        setTriggerPost(true);
        dispatch(postInsuranceTypeClearData());
    };
    var closeDrawer = function () {
        setOpenDrawer(false);
        setTrigger(true);
    };
    var onChangePage = function (e) {
        setInsuranceTypePage(e);
        setTrigger(true);
    };
    var onChangeRowsPerPage = function (e) {
        setInsuranceTypeLimit(e);
        setTrigger(true);
    };
    return (_jsxs(React.Fragment, { children: [_jsx(LoadingAFY, { loading: loadingInsuranceType ||
                    loadingPostInsuranceType ||
                    loadingPatchInsuranceType ||
                    loadingDeleteEntity, backgroundColor: themeCore.colors.backgroundLoader, typeAnimation: typeLoaders.LogoAfy, sizeAnimation: 65, textLoading: loadingDeleteEntity
                    ? "Eliminando tipo de producto"
                    : "Cargando tios de producto...", textLoadingColor: themeCore.colors.third, spinnerColor: themeCore.colors.third }), seeToast.show &&
                showToast(position.topRight, seeToast.type, seeToast.message, function () {
                    setSeeToast({ show: false, message: "", type: typeAlert.success });
                }), _jsx(ViewInsuranceType, { title: "Tipo de Productos", projectTypeTitle: isUpdate ? "Modificar Tipo de Producto" : "Agregar Tipo de Producto", permissions: permissions, loadingInsuranceType: loadingInsuranceType, insuranceTypeOptions: insuranceTypeOptions, insuranceTypeList: insuranceTypeList, listClientId: listClientId, openModal: openModal, openModalConfirmDelete: openModalConfirmDelete, openModalCloneConfirm: openModalCloneConfirm, loadingPostInsuranceType: loadingPostInsuranceType, dataForm: dataForm, modalTitle: itemModal === null || itemModal === void 0 ? void 0 : itemModal.title, onSaveData: handleSubmitInsuranceType, clickView: clickView, onClickDelete: handleDelete, onSubmitClone: handleClone, onCloseCloneModal: handleCloseCloneModal, onClickAdd: handleOnClickAdd, onClickContextMenu: onClickContextMenu, filterStatus: filterStatus, searchFilter: searchFilter, onCloseSearch: onCloseSearch, openDrawer: openDrawer, onCloseDrawer: closeDrawer, setOpenModalConfirmDelete: setOpenModalConfirmDelete, insuranceTypePage: insuranceTypePage, insuranceTypeLimit: insuranceTypeLimit, countPagination: countPagination, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, titleDrawer: titleDrawer })] }));
};
export default InsuranceTypeAdmin;
